import React, { createContext, useContext, useState } from "react";

const DashboardContext = createContext(undefined);
export const DashboardProvider = ({
  children,
}) => {
    const [hasIncome, setHasIncome] = useState(true);
    return (
        <DashboardContext.Provider
        value={{
            hasIncome,
            setHasIncome,
        }}
        >
            {children}
        </DashboardContext.Provider>
    );
};
export const useDashboardContext = () => {
  const context = useContext(DashboardContext);
  if (!context) {
    throw new Error("useDashboardContext must be used within a DashboardProvider");
  }
  return context;
};